import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ProjectStakeholderStoreActions,
  ProjectStakeholderStoreSelectors,
  ProjectStakeholderStoreReducer,
} from './index';
import { ProjectStakeholderDto } from '@cradua/data';

@Injectable()
export class ProjectStakeholderFacade {
  constructor(
    private store: Store<
      ProjectStakeholderStoreReducer.ProjectStakeholderPartialState
    >
  ) {}

  projectManagementRecord$ = this.store.select(
    ProjectStakeholderStoreSelectors.getSelected
  );
  searchedStudentRecord$ = this.store.select(
    ProjectStakeholderStoreSelectors.getSearchStudentRecord
  );

  projectManagementRecordError$ = this.store.select(
    ProjectStakeholderStoreSelectors.getProjectStakeholderError
  );

  getselected() {
    return this.store.select(ProjectStakeholderStoreSelectors.getSelected);
  }

  get isLoadingProjectStakeholder() {
    this.store.dispatch(
      ProjectStakeholderStoreActions.loadProjectStakeholder()
    );
    return this.store.select(
      ProjectStakeholderStoreSelectors.loadingProjectStakeholder
    );
  }

  get loadProjectStakeholder() {
    this.store.dispatch(
      ProjectStakeholderStoreActions.loadProjectStakeholder()
    );
    return this.store.select(
      ProjectStakeholderStoreSelectors.getAllProjectStakeholder
    );
  }

  searchProjectStakeholderRecord(query) {
    this.store.dispatch(
      ProjectStakeholderStoreActions.searchProjectStakeholderRecord({ query })
    );
  }

  addProjectStakeholder(newProjectStakeholder: ProjectStakeholderDto[]) {
    this.store.dispatch(
      ProjectStakeholderStoreActions.addProjectStakeholder({
        newProjectStakeholder,
      })
    );
  }

  updateProjectStakeholder(updateProjectStakeholder: ProjectStakeholderDto[]) {
    this.store.dispatch(
      ProjectStakeholderStoreActions.updateProjectStakeholder({
        updateProjectStakeholder,
      })
    );
  }

  removeProjectStakeholder(ids: string[]) {
    this.store.dispatch(
      ProjectStakeholderStoreActions.removeProjectStakeholder({ ids })
    );
  }
}
